import React from 'react';
import styled from 'styled-components';

import { colors } from '../ui-components';

/**
 * Rich-renderer function that can be consumed by React-Rich-Text render in order
 * to generate a styled element based on a particular rich text node, and it's
 * children
 *
 * @function
 * @param {object} node rich-text node
 */
const RichCode = node => {
  return <StyledCode size="large">{node}</StyledCode>;
};

const StyledCode = styled.code`
  display: block;
  padding: 24px;
  background-color: ${colors.gray5};
`;

export default RichCode;
